<template>
  <div class="data-import-container">
    <el-tabs v-model="activeTab">
      <!-- 手动添加数据 -->
      <el-tab-pane label="手动添加" name="manual">
        <el-form :model="manualForm" :rules="rules" ref="manualForm" label-width="100px" class="manual-form">
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="manualForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="manualForm.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="来源" prop="source">
            <el-input v-model="manualForm.source" placeholder="请输入来源"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <el-input
              type="textarea"
              v-model="manualForm.content"
              :rows="4"
              placeholder="请输入内容">
            </el-input>
          </el-form-item>
          <el-form-item label="源链接" prop="link">
            <el-input v-model="manualForm.link" placeholder="请输入源链接"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click.prevent="submitManualForm">提交</el-button>
            <el-button @click.prevent="resetManualForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- Excel导入 -->
      <el-tab-pane label="Excel导入" name="excel">
        <div class="excel-upload-container">
          <el-upload
            name="file"
            class="excel-uploader"
            drag
            :action="`${this.baseUrl}/news/upload`"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-success="handleSuccess"
            :on-error="handleError"
            accept=".xlsx">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传 xlsx 文件</div>
          </el-upload>
          
          <div class="template-download">
            <el-button type="text" @click="downloadTemplate">
              <i class="el-icon-download"></i> 下载导入模板
            </el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";
import content from '@/assets/test.xlsx';
export default {
  name: 'DataImport',
  computed:{
    ...mapState(['baseUrl'])
  },
  data() {
    return {
      activeTab: 'manual',
      manualForm: {
        date: '',
        title: '',
        source: '',
        content: '',
        link: '',
        tag:null,
        finish: 0,
        company:"待定"
      },
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        source: [
          { required: true, message: '请输入来源', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        link: [
          { required: true, message: '请输入源链接', trigger: 'blur' },
          { type: 'url', message: '请输入正确的URL格式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitManualForm() {
      this.$refs.manualForm.validate((valid) => {
        if (valid) {
          // 这里添加提交到服务器的逻辑
          axios.post(`${this.baseUrl}/news/`,this.manualForm).then(res => {
            if (res.data.success){
              this.$message.success(res.data.msg)
            }else {
              this.$message.error(res.data.msg)
            }
          }).catch(error => {
            this.$message.error(error)
          }).finally(() => {
            this.resetManualForm()
          })
        }
      })
    },
    resetManualForm() {
      this.$refs.manualForm.resetFields()
    },
    handlePreview(file) {
      console.log('预览文件:', file)
    },
    handleRemove(file, fileList) {
      console.log('移除文件:', file, fileList)
    },
    beforeRemove(file) {
      // return this.$confirm(`确定移除 ${file.name}？`)
      this.$confirm(`文件 ${file.name} 已经上传到服务器，无法删除`)
      return false
    },
    handleSuccess(response) {
      console.log(response);
      if(response.success){
        this.$message.success(response.msg)
      }else {
        this.$message.error(response.msg)
      }
    },
    handleError(err) {
      this.$message.error('上传失败')
      console.error('上传失败:', err)
    },
    downloadTemplate() {

      // 这里添加下载模板的逻辑
      this.$message.success('开始下载模板')
      fetch(content)
          .then(response => response.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'template.xlsx');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          })
          .catch(error => {
            console.error(error);
          });
    }
  }
}
</script>

<style scoped>
.data-import-container {
  padding: 20px;
  height: 100%;
}

.manual-form {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #1e1f22;
}

.excel-upload-container {
  max-width: 600px;
  margin: 20px auto;
  text-align: center;
}

.excel-uploader {
  border: 1px dashed #1e1f22;
  border-radius: 4px;
  padding: 20px;
}

.excel-uploader .el-upload {
  width: 100%;
}

.excel-uploader .el-upload-dragger {
  width: 100%;
  border-color: #2b2d30;
}

.excel-uploader .el-upload-dragger:hover {
  border-color: #409EFF;
}



.excel-uploader .el-upload__text em {
  color: #409EFF;
}



.template-download {
  margin-top: 20px;
}

.template-download .el-button {
  color: #409EFF;
}

.template-download .el-button:hover {
  color: #66b1ff;
}
</style> 